import React from 'react'
import styles from './trx-action.module.scss'
import { DIDPOINT_ACTIONS } from '@did/constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { IDidPointRecord } from '@did/types'
import { Iconfont } from '@did/uikit'
import { RECORD_STATUS } from '@did/das-balance-constants'

interface TrxActionProps {
  recordInfo: IDidPointRecord
}

const TrxAction: React.FC<TrxActionProps> = ({ recordInfo }) => {
  const { tt } = useDasBalanceContext()
  const getTrxAction = (action: string) => {
    let text = ''
    switch (action) {
      case DIDPOINT_ACTIONS.burn:
        text = tt('Withdraw')
        break
      case DIDPOINT_ACTIONS.transfer_deposit:
        text = tt('Top up')
        break
      case DIDPOINT_ACTIONS.transfer_refund:
        text = tt('Refund')
        break
      case DIDPOINT_ACTIONS.transfer_tldid:
      case DIDPOINT_ACTIONS.transfer_sldid:
        text = tt('Register or Renew')
        break
      case DIDPOINT_ACTIONS.transfer_auction:
        text = tt('Dutch auction')
        break
      case DIDPOINT_ACTIONS.transfer_coupon:
        text = tt('Create coupon')
        break
    }
    return text
  }

  return (
    <span className="inline-flex flex-col items-end">
      <span
        className={`${styles.trxAction} ${
          styles[`trxAction__action__${recordInfo.action_dp}`]
        }`}
      >
        {getTrxAction(recordInfo.action_dp)}
      </span>
      {recordInfo.record_status === RECORD_STATUS.processing && (
        <span className="inline-flex items-center text-[#636D85] text-sm mt-1">
          <Iconfont
            className="animate-spin mr-1"
            name="loading"
            size={16}
            color="#B0B8BF"
          />
          {tt('Processing')}
        </span>
      )}
    </span>
  )
}

export default TrxAction
